export const NAVIGATE_TO_PLAYER = '@PLAYER/NAVIGATE_TO_PLAYER';
